import { render, staticRenderFns } from "./QuickBetItem.vue?vue&type=template&id=987d15e6&scoped=true"
import script from "./QuickBetItem.vue?vue&type=script&lang=js"
export * from "./QuickBetItem.vue?vue&type=script&lang=js"
import style0 from "./QuickBetItem.vue?vue&type=style&index=0&id=987d15e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987d15e6",
  null
  
)

export default component.exports